import React from "react";
import { General } from "../../../lib/types";

interface IProps {
  general: General;
}

const GeneralInfo = ({
  general
}: IProps) => (
  <div className="dialog-content">
    <table className="table">
      <tbody>
      {general.specializations
        .map(specialization => <tr>
          <th>{specialization.name}</th>
          <td>
            {specialization.qualities
              .reduce((level: number, quality) => level += quality.level, 0)}
          </td>
        </tr>)
      }
      </tbody>
    </table>
  </div>
)

export default GeneralInfo;
